import { render } from "./Share.vue?vue&type=template&id=dddfb336&scoped=true"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"

import "./Share.vue?vue&type=style&index=0&id=dddfb336&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dddfb336"]])

export default __exports__